import { Component, Input } from '@angular/core';
import { UserAlert } from '@cigna/chcp/shared/util';

@Component({
  selector: 'cigna-alerts-tasks',
  templateUrl: './alerts-tasks.component.html',
  styleUrl: './alerts-tasks.component.scss',
})
export class AlertsTasksComponent {
  @Input() alerts: UserAlert[] = [];

  isExpanded = false;

  get hasMultipleAlerts(): boolean {
    return this.alerts.length >= 2;
  }

  get visibleAlerts(): UserAlert[] {
    return !this.hasMultipleAlerts || this.isExpanded ? this.alerts : [];
  }

  toggleAlerts(): void {
    this.isExpanded = !this.isExpanded;
  }

  getStatus(alert: UserAlert): 'error' | 'warning' {
    return alert.priority === 1 ? 'error' : 'warning';
  }

  getEmphasis(alert: UserAlert): 'strong' | 'subtle' {
    return alert.priority === 1 ? 'strong' : 'subtle';
  }

  getCopyKey(alert: UserAlert, entry: 'heading' | 'body' | 'ctaText'): string {
    return `shared.alertsTasks.${alert.alertType}.${entry}`;
  }

  getCopyParams(alert: UserAlert): Record<string, string | undefined> {
    return {
      tin: alert.tin,
      deadlineDate: alert.deadlineDate,
    };
  }
}
